// Web-Login-Handoff fuer die native App: Die App oeffnet den Web-Login mit
// ?mobile=1. Nach erfolgreichem Login (E-Mail/Passwort oder Google/Microsoft)
// wird ein Einmal-Code an die App uebergeben (Custom-Scheme-Redirect), die ihn
// gegen eigene Tokens eintauscht.

export const MOBILE_AUTH_SCHEME = "dataoptimizer";

const FLAG_KEY = "mobileAuthFlow";

export function markMobileAuthFromSearch(search) {
  try {
    const params = new URLSearchParams(search || "");
    if (params.get("mobile") === "1") {
      sessionStorage.setItem(FLAG_KEY, "1");
    }
  } catch {
    // sessionStorage nicht verfuegbar – ignorieren.
  }
}

export function isMobileAuthFlow() {
  try {
    return sessionStorage.getItem(FLAG_KEY) === "1";
  } catch {
    return false;
  }
}

export function clearMobileAuthFlow() {
  try {
    sessionStorage.removeItem(FLAG_KEY);
  } catch {
    // ignorieren
  }
}

// Leitet den Browser zurueck in die App (Custom-Scheme) und uebergibt den Code.
export function redirectToMobileApp(code) {
  clearMobileAuthFlow();
  window.location.href = `${MOBILE_AUTH_SCHEME}://auth?code=${encodeURIComponent(code)}`;
}
